import styles from "./HorizontalRule.module.scss";
import { FeatureFlags } from "@/types/types.ts";

// @TODO: use StandardProps - can't use the them now due to incorrect usage of the HR component
type HorizontalRuleProps = {
  flags?: FeatureFlags;
};

export function HorizontalRule({ flags }: HorizontalRuleProps) {
  if (flags?.hideHRComponent.value === true) {
    return null;
  }

  return <hr className={styles.hr} data-component="HorizontalRule" />;
}
